import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import qr from "query-string";
import type { StockStatus } from "@/utils/stockFilters";
import { Pagination, PaginationResponse } from "@/core/common/types";
import { ErpProduct } from "@/shared/core-products";

export const GET_ERP_PRODUCTS_FETCH_KEY = "getErpProducts";

type GetProductsParams = {
  storageId?: string;
  searchTerm?: string;
  zoneId?: string[] | string;
  showDisabled?: boolean;
  order?: string;
  sort?: string;
  stockStatus?: StockStatus;
} & Partial<Pagination>;

export const getErpProducts = async (
  storageId?: string,
  page = 1,
  pageSize = 10,
  searchTerm?: string,
  zoneId?: string[] | string,
  showDisabled?: boolean,
  order?: string,
  sort?: string,
  stockStatus?: StockStatus,
) => {
  const params = qr.stringify({
    storageId,
    page,
    pageSize,
    searchTerm,
    zoneId,
    showDisabled,
    order,
    sort,
    stockStatus,
  });
  const response = await fetcher.get(`${API.GESLUB}/erp-product?${params}`);
  return response.data;
};

export const useGetErpProducts = ({
  storageId,
  page,
  pageSize,
  searchTerm,
  zoneId,
  showDisabled,
  order,
  sort,
  stockStatus,
}: GetProductsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<ErpProduct>,
    Error
  >({
    placeholderData: (previousData) => previousData,
    queryKey: [
      GET_ERP_PRODUCTS_FETCH_KEY,
      storageId,
      page,
      pageSize,
      searchTerm,
      zoneId,
      showDisabled,
      order,
      sort,
      stockStatus,
    ],
    queryFn: () =>
      getErpProducts(
        storageId,
        page,
        pageSize,
        searchTerm,
        zoneId,
        showDisabled,
        order,
        sort,
        stockStatus,
      ),
  });
  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
